/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedGenderDropdownQueryResponse,
  GetApiV1PersonSharedGenderDropdown401,
  GetApiV1PersonSharedGenderDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedGenderDropdown.ts";

function getGetApiV1PersonSharedGenderDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/gender-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EGender para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de gêneros para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/gender-dropdown}
 */
export async function getApiV1PersonSharedGenderDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedGenderDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedGenderDropdown401
      | GetApiV1PersonSharedGenderDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedGenderDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
